import '@/javascript/application'

import SignInForm from '@vuejs/views/sign-in/SignInForm'

import initFlashMessages from '@/javascript/components/flash'

import { createVueApp } from './createVueApp'

initFlashMessages()

createVueApp(SignInForm).mount('#signInApp')
